import React, {Component} from 'react';
import BottomLinks from "./common/BottomLinks";
import queryString from 'query-string';
import SalesOpportunityService from '../services/SalesOpportunityService';
import DealsService from '../services/DealsService';
import Loader from './common/loader/Loader';
import BreadCrumb from "./common/BreadCrumb";
import {connect} from 'react-redux';
import * as Constants from './common/Constants';
import Alert from "./common/alert/alert";
import AuditService from "../services/AuditService";
import * as Tagging from './tagging/LeadFormTagging';

const emailRegex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
const cellNumberRegEx = /^((0(\d{13}))|(0(\d{9}))|(\+?27(\d{13}))|(\+?27(\d{9})))$/;       // /(^((06|07|08)(\d{8}))$)/; regex for standard number only//
const CONTRACT_TYPE = "New Contract";
const UPGRADE_TYPE = "Upgrade";
const EBU_Lead_Submission = "EBU_Lead_Submission";
const Email_Lead_Creation = "Email_Lead_Creation";
const START = 'START';
const COMPONENT_NAME = "vod-ms-ui-vb-leads";
let interest = '';
let statedCapturing = false;
class LeadForm extends Component {

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.getDeviceDeals = this.getDeviceDeals.bind(this);
    }

    state = {
        _productName: '',
        fullName: '',
        businessNameActive: '',
        landLineNumberActive: '',
        emailActive: '',
        cellNumberActive: '',
        businessSizeActive: true,
        provinceActive: true,
        SectorActive: true,
        fullNameActive: '',
        loader: false,
        comments: '',
        firstName: '',
        mobileNumber: '',
        emailAddress: '',
        businessSize: '1 - 9 Small business',
        province: 'Gauteng',
        sector: 'Public Sector',
        businessName: '',
        landLineNumber: '',
        dealSheetNo: '',
        dealDesc: '',
        dealPackageName: '',
        dealReferenceNumber: '',
        dealModel: '',
        totalMonthlySubscription: '',
        leadType: '',
        requestType: '',
        validLandLineNumber: false,
        validCellNumber: false,
        validEmail: false,
        showAlert : false,
        maxAttempt: false,
        isEmailLead: false
    }


    componentDidMount() {
        document.title = 'Call me back';
        let params = queryString.parse(this.props.location.search);
        if (params !== undefined) {
            let reqType = "";
            let deviceId = "";
            let dealId = "";
            let model = '';
            let maxAttempt = false;
            let userFirstName = '';
            let fullName = '';
            let fullNameActiveTemp = false;
            let mobileNumberActiveTemp = false;
            let validateMsisdn = true;
            let msisdn = '';
            if (!Constants.isUndefined(params.requestType)
                && !Constants.isUndefined(params.dealId)
                && !Constants.isUndefined(params.deviceId)) {

                if (!Constants.isUndefined(params.deviceId)) {
                    deviceId = params.deviceId;
                }
                if (!Constants.isUndefined(params.requestType)) {
                    reqType = params.requestType;
                }
                if (!Constants.isUndefined(params.dealId)) {
                    dealId = params.dealId;
                }
                if (!Constants.isUndefined(params.model)) {
                    model = params.model;
                }
                if (!Constants.isUndefined(params.msisdn)) {
                    msisdn = params.msisdn;
                    mobileNumberActiveTemp = true;
                    validateMsisdn = this.validCellPhone(msisdn)
                }
                if (!Constants.isUndefined(params.firstName)) {
                    userFirstName = params.firstName;
                    fullName = userFirstName;
                    fullNameActiveTemp = true;
                }
                if (!Constants.isUndefined(params.lastName)) {
                    fullName = userFirstName+' '+params.lastName;
                    fullNameActiveTemp = true;
                }
                if (!Constants.isUndefined(params.maxAttempt)) {
                    maxAttempt = params.maxAttempt;
                    if(maxAttempt)
                        this.showAlert(true);
                }
                this.setState({requestType: reqType, dealModel: model, userFirstName: userFirstName, maxAttempt: maxAttempt,
                    firstName: fullName, fullNameActive : fullNameActiveTemp, mobileNumber: msisdn,cellNumberActive: mobileNumberActiveTemp,
                    validCellNumber: validateMsisdn});

                this.getDeviceDeals(deviceId, dealId, params, reqType);
                this.getIsEmail();
                return;
            } else {
                this.setState({requestType: "contract"});
            }
            this.getLeadInfo({params, reqType});
        }
        this.getIsEmail();
    }

    getLeadInfo = ({params, leadType = '', obj = {}, product = 'I am interested in', reqType = '', dealDetail = {}}) => {
        let _productName = '';
            if (!Constants.isUndefined(params.dealId)) {
                leadType = 'GSM';
                interest = 'GSM';
                obj = {msisdn: params.msisdn}
                if (!Constants.isUndefined(params.model)) {
                    product = `I am interested in ${params.model}`;
                }

            } else {
                leadType = 'FIXED';
                if (!Constants.isUndefined(params.PRODUCT)) {
                    interest = params.PRODUCT;
                    product = `I am interested in ${params.PRODUCT}`;
                    _productName = params.PRODUCT;
                }
            }
            this.props.setProductName({productName: _productName});
            let productVal = params.PRODUCT;

            Tagging.viewLeadFormEvent((reqType === 'contract' || reqType === 'upgrades') ? 'GSM' : 'FIXED', obj, reqType, productVal, dealDetail);
            this.setState({
                comments: product,
                leadType: leadType,
                _productName: _productName
            });
    };

    activateField = (e) => {
        this.setState({
            [`${e.target.id}Active`]: true
        });
    };

    disableField = (e) => {
        if (e.target.value === "") {
            this.setState({
                [`${e.target.id}Active`]: false
            });
        }
    };

    validateForm() {
        this.myRef.current = false;
        if (this.state.firstName === '' || this.state.mobileNumber === '' || this.state.emailAddress === '' ||
            this.state.comments === '' ||
            this.state.businessName === '' || this.state.businessSize === '' || this.state.province === '') {
            this.myRef.current = false;
        } else {
            if (!emailRegex.test(this.state.emailAddress)) {
                this.myRef.current = false;
            } else if (!this.validCellPhone(this.state.mobileNumber)) {
                this.myRef.current = false;
            } else if (!Constants.isUndefined(this.state.landLineNumber) && !this.validCellPhone(this.state.landLineNumber)) {
                this.myRef.current = false;
            } else if (!emailRegex.test(this.state.emailAddress)) {
                this.myRef.current = false;
            } else {
                this.myRef.current = true;
            }
        }
    }

    hasTwoZero = str => {
        return (str.length > 1 ? (str.slice(0,2) === '00') : false);
    }

    validCellPhone = value => {
        let validCell;
        let hasTwoZero = this.hasTwoZero(value);

        if (!hasTwoZero) {
            validCell = cellNumberRegEx.test(value);
        } else {
            validCell = false;
        }
        return validCell;
    }

    handleChange(e) {
        if (!statedCapturing) {
            Tagging.startCompletingFormEvent(this.state.leadType, this.state.requestType, this.state._productName);
        }
        statedCapturing = true;
        let value = e.target.value;
        switch (e.target.id) {
            case "fullName":
                this.setState({firstName: value});
                break;
            case "cellNumber":
                this.setState({mobileNumber: value, validCellNumber: this.validCellPhone(value)});
                break;
            case "email":
                this.setState({emailAddress: value, validEmail: emailRegex.test(value)});
                break;
            case "landLineNumber":
                this.setState({landLineNumber: value, validLandLineNumber: this.validCellPhone(value)});
                break;
            case "comments":
                this.setState({comments: value});
                break;
            case "businessName":
                this.setState({businessName: value});
                break;
            case "businessSize":
                this.setState({
                    [`${e.target.id}Active`]: !(value === "")
                });
                this.setState({businessSize: value});
                break;
            case "province":
                this.setState({
                    [`${e.target.id}Active`]: !(value === "")
                });
                this.setState({province: value});
                break;
            case "sector":
                this.setState({
                    [`${e.target.id}Active`]: !(value === "")
                });
                this.setState({sector: value});
                Tagging.sectorChangeEvent(value);
                break;
            default:
                break;
        }
    }

    getDeviceDeals = (deviceId, dealId, params, reqType) => {
        this.setState({loader: true});
        DealsService.getDealsForDevice(deviceId)
            .then((res) => {
                this.setState({loader: false});
                const deals = res.data.result.deals;
                deals.map((e, i) => {
                        if (parseInt(dealId) === parseInt(e.dealId)) {
                            this.setState({
                                dealSheetNo: e.dealsheetNumber,
                                dealDesc: e.packageDetail.packageDescription,
                                dealPackageName: e.packageDetail.packageTypeName,
                                dealReferenceNumber: e.dealId,
                                totalMonthlySubscription: e.totalMonthlySubscription
                            }, () => {
                                this.getLeadInfo({params, reqType, dealDetail: e});   
                            })
                        }
                    }
                )
            }).catch((error) => {
            this.setState({loader: false});
            console.log(error);
        })
    }

    submitLead = () => {
        let data = {};
        this.setState({loader: true, showAlert: false});
        if(this.state.isEmailLead){
            data = {
                "comments": this.state.comments,
                "firstName": this.state.firstName,
                "mobileNumber": this.state.mobileNumber,
                "emailAddress": this.state.emailAddress,
                "businessSize": this.state.businessSize,
                "province": this.state.province === "The Western Cape" ? "Western Cape" : this.state.province,
                "businessName": this.state.businessName,
                "alternateContactNumber": this.state.landLineNumber,
                "requestType": CONTRACT_TYPE,
                "interest" : interest,
                "sector": this.state.sector
            }
            AuditService.addAuditEvent(Email_Lead_Creation+"_"+interest, 'submit email leads '+interest, START,
            null, null, COMPONENT_NAME,"EMAILLEAD",interest);
            SalesOpportunityService.submitEmailLead(data)
            .then((response) => {
                this.setState({loader: false});
                window.location.href = `${process.env.REACT_APP_BASE}/success/${this.state.leadType.toLowerCase()}/${this.state._productName}`;
            }).catch((error) => {
                this.setState({loader: false, showAlert: true});
                console.log(error);
            })
        }
        else{
        if(this.state.requestType === 'contract' || this.state.requestType === 'upgrades'){
            /* deals grid view */
            data = {
                "dealSheetNo": this.state.dealSheetNo,
                "dealDesc": this.state.dealDesc,
                "dealPackageName": this.state.dealPackageName,
                "dealReferenceNumber": this.state.dealReferenceNumber,
                "dealModel": this.state.dealModel,
                "totalMonthlySubscription": this.state.totalMonthlySubscription,
                "leadType": this.state.leadType,
                "requestType": this.state.requestType === 'contract' ? CONTRACT_TYPE : UPGRADE_TYPE,
                "comments": this.state.comments,
                "firstName": this.state.firstName,
                "mobileNumber": this.state.mobileNumber,
                "emailAddress": this.state.emailAddress,
                "businessSize": this.state.businessSize,
                "province": this.state.province === "The Western Cape" ? "Western Cape" : this.state.province,
                "businessName": this.state.businessName,
                "alternateContactNumber": this.state.landLineNumber,
                "interest" : interest
            }
        }else{
            /* default data */
            data = {
                "comments": this.state.comments,
                "firstName": this.state.firstName,
                "mobileNumber": this.state.mobileNumber,
                "emailAddress": this.state.emailAddress,
                "businessSize": this.state.businessSize,
                "province": this.state.province === "The Western Cape" ? "Western Cape" : this.state.province,
                "businessName": this.state.businessName,
                "alternateContactNumber": this.state.landLineNumber,
                "leadType": this.state.leadType,
                "requestType": CONTRACT_TYPE,
                "interest" : interest
            }
        }
        AuditService.addAuditEvent(EBU_Lead_Submission, 'submit leads', START,
            null, null, COMPONENT_NAME,interest,"");
        SalesOpportunityService.submitCommonLead(data)
            .then((response) => {
                this.setState({loader: false});
                if(this.state.leadType.toLowerCase() === 'gsm'){
                    window.location.href = `${process.env.REACT_APP_BASE}/success/${this.state.leadType.toLowerCase()}/${this.state.requestType}/${response.data.result.reference}/${this.state.dealModel}/${queryString.parse(this.props.location.search).deviceId}/${queryString.parse(this.props.location.search).dealId}`;
                }else {
                    window.location.href = `${process.env.REACT_APP_BASE}/success/${this.state.leadType.toLowerCase()}/${this.state.requestType}/${response.data.result.reference}/${this.state._productName}`;
                }

            }).catch((error) => {
            this.setState({loader: false, showAlert: true});
            console.log(error);
        })
    }
    }

    showAlert = show => {
        this.setState({showAlert: show});
    }

    getIsEmail=()=>{
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const product_type = urlParams.get('PRODUCT');
        if(product_type !== null){
            Constants.productNameList.map((productName)=>{
                productName === product_type && this.setState({...this.state, isEmailLead:true, _productName:productName, leadType: "EMAIL", comments:`I am interested in ${productName}`});
            })
        }
    }


    render() {
        this.validateForm();
        return (
            <React.Fragment>
                {this.state.showAlert && <Alert leadType={this.state.leadType} showAlert={this.showAlert} maxAttempt={this.state.maxAttempt} />}
                <div className="main-content-wrapper" disabled={this.state.showAlert}>
                    <BreadCrumb currentPage={'Call me back'}/>
                    {(this.state.requestType === 'upgrades' && this.state.userFirstName !== undefined && this.state.userFirstName !== '') && <div className="popUP-section overlay-message">
                    <div class="main-content-wrapper">
                        <div className="success">
                        <BreadCrumb currentPage={'Upgrade'}/>
                            <span className="svgOuter"><svg focusable="false" aria-hidden="true" className="icon top-svg">
                                    <use xlink="http://www.w3.org/1999/xlink" href="#icon-tick"></use>
                                </svg></span>
                            <label className="title">You can upgrade, {this.state.userFirstName}!</label>
                            <span className="sub-title">The wait is finally over!</span>
                        </div>
                        </div>
                    </div>}
                    <div className={(this.state.requestType === 'upgrades' && this.state.userFirstName !== undefined && this.state.userFirstName !== '') ? "parent-main-wrapper deals-popup leads-form" : "parent-main-wrapper leads-form"}>
                        {(this.state.requestType === 'upgrades' && this.state.userFirstName !== undefined && this.state.userFirstName !== '') &&
                        <React.Fragment>
                            <label className="page-title-deal-popup">Let us give you a call to complete your upgrade</label>
                            <label className="sub-title" automationid="LeadForm_Label_SubTitle_1">One of our call centre agents can contact you within the next 24 hours to help you upgrade telephonically</label>
                        </React.Fragment>
                        }
                        {(this.state.requestType !== 'upgrades' || (this.state.requestType === 'upgrades' && (this.state.userFirstName === undefined || this.state.userFirstName === '')) ) &&
                            <React.Fragment>
                                <svg focusable="false" aria-hidden="true" className="icon headerSvg">
                                    <use xlink="http://www.w3.org/1999/xlink" href="#icon-landline-or-call"></use>
                                </svg>
                                <label className="page-title" automationid="LeadForm_Label_PageTitle_1">Let us call you back</label>
                                <label className="sub-title" automationid="LeadForm_Label_SubTitle_1">Please enter your details below and a call centre agent will get back to you as soon as possible.</label>
                            </React.Fragment>
                        }
                        <div className="multi-column-row">
                            <div className="form-input field-error">
                                <label automationid="LeadForm_Label_FullName_1" className={this.state.fullNameActive ? "labelAnimate" : null}>* Full name</label>
                                <input id="fullName"
                                       automationid="LeadForm_Input_FullName_1"
                                       value={this.state.firstName}
                                       onFocus={this.activateField} onBlur={this.disableField}
                                       type="text"
                                       onChange={this.handleChange}/>
                            </div>
                            <div className="form-input">
                                <label automationid="LeadForm_Label_CellNumber_1" className={this.state.cellNumberActive ? "labelAnimate" : null}>* Cellphone
                                    number</label>
                                <input id="cellNumber"
                                       automationid="LeadForm_Input_CellNumber_1"
                                       value={this.state.mobileNumber}
                                       onFocus={this.activateField} onBlur={this.disableField}
                                       type="text"
                                       onChange={this.handleChange}/>
                                {(this.state.mobileNumber !== '' && !this.state.validCellNumber &&
                                    <span automationid="LeadForm_Span_CellNumberErr_1" className="error-message">Please enter a valid Cellphone number</span>)}
                            </div>
                            <div className="form-input">
                                <label automationid="LeadForm_Label_Email_1" className={this.state.emailActive ? "labelAnimate" : null}>* Email
                                    address</label>
                                <input id="email"
                                       automationid="LeadForm_Input_Email_1"
                                       value={this.state.emailAddress}
                                       onFocus={this.activateField} onBlur={this.disableField}
                                       type="text"
                                       onChange={this.handleChange}/>
                                {(this.state.emailAddress !== '' && !this.state.validEmail) &&
                                <span automationid="LeadForm_Span_EmailErr_1" className="error-message">Please enter a valid Email address</span>}
                            </div>
                            <div className="form-input">
                                <label automationid="LeadForm_Label_LandlineNumber_1" className={this.state.landLineNumberActive ? "labelAnimate" : null}>&nbsp;&nbsp;Landline
                                    number</label>
                                <input id="landLineNumber"
                                       automationid="LeadForm_Input_LandlineNumber_1"
                                       value={this.state.landLineNumber}
                                       onFocus={this.activateField} onBlur={this.disableField}
                                       type="text"
                                       onChange={this.handleChange}/>
                                {this.state.landLineNumber !== '' && !this.state.validLandLineNumber &&
                                <span automationid="LeadForm_Span_LandlineNumber_1" className="error-message">Please enter a valid Landline number</span>}
                            </div>
                            <div className="form-input ">
                                <label automationid="LeadForm_Label_BusinessSize_1" className={this.state.businessSizeActive ? "labelAnimate" : null}>* Business
                                    size</label>
                                <select id="businessSize" automationid="LeadForm_Select_BusinessSize_1" onChange={this.handleChange} value={this.state.businessSize}>
                                    <option value="1 - 9 Small business">1 - 9 Small business</option>
                                    <option value="10 - 99 Medium business">10 - 99 Medium business</option>
                                    <option value="100+ Large enterprise">100+ Large enterprise</option>
                                    <option value="Public sector">Public sector</option>
                                </select>
                                <span className="arrow-down"></span>
                            </div>
                            <div className="form-input">
                                <label automationid="LeadForm_Label_BusinessName_1" className={this.state.businessNameActive ? "labelAnimate" : null}>* Business
                                    name</label>
                                <input id="businessName"automationid="LeadForm_Input_BusinessName_1"
                                       value={this.state.businessName}
                                       onFocus={this.activateField} onBlur={this.disableField}
                                       type="text"
                                       onChange={this.handleChange}/>
                            </div>
                            <div className="form-input ">
                                <label automationid="LeadForm_Label_Province_1" className={this.state.provinceActive ? "labelAnimate" : null}>* Province</label>
                                <select automationid="LeadForm_Input_Province_1" id="province" onChange={this.handleChange} value={this.state.province}>
                                    <option value="Gauteng">Gauteng</option>
                                    <option value="Kwazulu Natal">KwaZulu-Natal</option>
                                    <option value="Limpopo">Limpopo</option>
                                    <option value="North West">North West</option>
                                    <option value="Mpumalanga">Mpumalanga</option>
                                    <option value="Eastern Cape">Eastern Cape</option>
                                    <option value="Central">Free State</option>
                                    <option value="Northern Cape">Northern Cape</option>
                                    <option value="Western Cape">Western Cape</option>
                                </select>
                                <span className="arrow-down"></span>
                            </div>
                            {this.state.isEmailLead &&
                            <div className="form-input ">
                                <label automationid="LeadForm_Label_Sector_1" className={this.state.SectorActive ? "labelAnimate" : null}>* Sector</label>
                                <select automationid="LeadForm_Input_Sector_1" id="sector" onChange={(e)=>{this.handleChange(e)}} value={this.state.sector} onFocus={()=>{Tagging.sectorCaptureFormEvent()}}>
                                    <option value="Public Sector">Public Sector</option>
                                    <option value="Private Sector">Private Sector</option>
                                    <option value="International (Africa)">International (Africa)</option>
                                </select>
                                <span className="arrow-down"></span>
                            </div>
                            }
                            <div className="form-input textAreaBlock">
                                <textarea automationid="LeadForm_TextArea_Comments_1" value={this.state.comments}
                                          id="comments"
                                          maxLength="250"
                                          onChange={this.handleChange}
                                          rows="9" placeholder="I am interested in…"></textarea>
                            </div>
                            <div className="btn-row">
                                <label onClick={this.submitLead}
                                       automationid="LeadForm_Link_CallMeBack_1"
                                       className={"btn-red" + (this.myRef.current ? '' : ' disabled')}>Call me
                                    back</label>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomLinks/>
                {this.state.loader ? <Loader/> : null}
            </React.Fragment>
        );
    }

}

const mapDispatchToProps = dispatch => {
    return {
        setProductName: (response) => dispatch({
            type: Constants.SET_PRODUCT_NAME,
            payload: response
        })
    }
}


export default connect(null, mapDispatchToProps)(LeadForm);
